export enum PublicationCreationMode {
    Library = 'library',
    Own = 'own',
}

export type PublicationLibraryCreationMode = Extract<
    PublicationCreationMode,
    PublicationCreationMode.Library
>;

export type PublicationOwnCreationMode = Extract<
    PublicationCreationMode,
    PublicationCreationMode.Own
>;

export function isPublicationLibraryCreationMode(
    mode: PublicationCreationMode | undefined,
): mode is PublicationLibraryCreationMode {
    return mode === PublicationCreationMode.Library;
}

export function isPublicationOwnCreationMode(
    mode: PublicationCreationMode | undefined,
): mode is PublicationOwnCreationMode {
    return mode === PublicationCreationMode.Own;
}
